import { JobListCardItem } from 'containers/dispatch/dispatch.model';

export interface MapJobSsePayload {
  data?: {
    job?: JobListCardItem;
    isCreated?: boolean;
  };
}

const hasValidCoordinates = (job: JobListCardItem) => {
  const lat = job.customer?.address?.latitude;
  const lng = job.customer?.address?.longitude;
  return lat != null && lng != null;
};

export const applyJobListSseUpdate = (jobsList: JobListCardItem[], sseData: MapJobSsePayload): JobListCardItem[] => {
  const { job, isCreated } = sseData.data ?? { job: undefined, isCreated: false };

  if (!job) {
    return jobsList;
  }

  const existingIndex = jobsList.findIndex(item => item.jobId === job.jobId);

  if (existingIndex >= 0) {
    if (jobsList[existingIndex] === job) {
      return jobsList;
    }

    const next = [...jobsList];
    next[existingIndex] = job;
    return next;
  }

  if (!isCreated) {
    return jobsList;
  }

  if (!hasValidCoordinates(job)) {
    return jobsList;
  }

  return [job, ...jobsList];
};
